
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { Form as ElForm } from 'element-ui'
import { setEnterprise } from '@/api/universal'

@Component({
  name: 'setTimezone',
  components: {}
})
export default class extends Vue {
  @Prop({ default: true }) enterprise!: any

  private infoForm: any = {
    currency_timezone_map: {}
  }
  private availableCurrency = this.enterprise.available_currency
  private loading: boolean = false
  // 时区
  private timeZone = AppModule.constant['TIMEZONE_MAP']
  private timeZoneList: any[] = []
  private getTimeZoneList () {
    this.timeZoneList = Object.keys(this.timeZone).map(v => {
      return { value: this.timeZone[v], label: v }
    })
  }

  private back () {
    this.$emit('close')
  }

  private async confirm () {
    try {
      this.loading = true
      const data: any = {
        ssl_switch: {
          currency_timezone_map: this.infoForm.currency_timezone_map
        }
      }
      await setEnterprise(data).then((res: any) => {
        this.$message({
          message: 'Operation Successfully!',
          type: 'success'
        })
        sessionStorage.setItem(
          'timeZoneData',
          JSON.stringify(res.available_currency_timezone)
        )
        this.back()
        this.loading = false
        window.location.reload()
      })
    } catch (e) {}
  }

  private init () {
    if (this.enterprise.ssl_switch.currency_timezone_map) {
      this.infoForm.currency_timezone_map = this.enterprise.ssl_switch.currency_timezone_map
    } else {
      this.infoForm.currency_timezone_map = {}
    }
  }

  mounted () {
    this.getTimeZoneList()
    this.init()
  }
}
